import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Card } from '@wundo/ui';
import { resolveOrganisationFeatures } from '@wundo/shared/organisationFeature.ts';
import { getOrganisation } from '@/lib/organisations.ts';

/**
 * Staff can set journeys up before the organisation runs them, but its
 * managers see nothing until the `journeys` feature is on. Says so, with the
 * way to the form where it is switched on. Nothing while it is on.
 */
export function JourneysFeatureNotice({ organisationId }: { organisationId: string }) {
  const { data: organisation } = useQuery({
    queryKey: ['organisation', organisationId],
    queryFn: () => getOrganisation(organisationId),
  });

  if (!organisation || resolveOrganisationFeatures(organisation.features).journeys) {
    return null;
  }

  return (
    <Card tone='accent' role='status' className='text-sm text-ink'>
      Journeys are off for {organisation.name}: its managers do not see these journeys and
      get no reminders.{' '}
      <Link
        to='/organisations/$id/edit'
        params={{ id: organisationId }}
        className='font-semibold underline'
      >
        Turn them on in the organisation settings
      </Link>
    </Card>
  );
}
